import React, { ReactElement, ReactNode } from 'react'
import { Box, Flex } from 'theme-ui'
import CloseButtonPopUp from 'images/barry/closebutton.svg'
import { Svg } from 'ui/Svg'
import useGetColorMode from 'utils/useGetColorMode'
import { Button } from 'ui'

export enum BarryPopUpMessagAction {
  HIDE = 'show',
  OPEN = 'open',
}

export default function BarryPopUp({
  barryMessage,
  handlePopupInteraction,
}: {
  barryMessage?: ReactNode
  handlePopupInteraction: (action: BarryPopUpMessagAction) => void
}): ReactElement {
  const { isLightMode } = useGetColorMode()

  return (
    <>
      <Flex
        sx={{
          width: '20rem',
          height: 'auto',
          zIndex: 'zIndex625',
          position: 'absolute',
          bottom: '9.4rem',
          right: ['4.0rem', '4.8rem'],
          boxShadow: isLightMode
            ? '0 1px 20px -5px rgba(0, 0, 0, 0.45)'
            : '0px 1px 0.2px 0px rgba(255, 255, 255, 0.1) inset',
          backgroundColor: isLightMode ? 'commonAliceBlue' : 'spaceCadet',
          borderRadius: '1.2rem 1.2rem 0rem 1.2rem',
          flexDirection: 'column',
          p: '1.2rem',
        }}
      >
        <Button
          variant="transparent"
          ariaLabel="close popup"
          data-testid="popup-close"
          sx={{
            boxShadow: isLightMode
              ? '0px 1px 0.2px 0px rgba(0, 0, 0, 0.1) inset'
              : '0px 1px 0.2px 0px rgba(255, 255, 255, 0.1) inset',
            backgroundColor: isLightMode ? 'commonAliceBlue' : 'spaceCadet',
            p: '0.3rem',
            borderTopLeftRadius: '10rem',
            borderTopRightRadius: '10rem',
            borderBottomLeftRadius: '10rem',
            borderBottomRightRadius: '0rem',
            top: '-1.1rem',
            right: '0rem',
            position: 'absolute',
          }}
          onClick={() => {
            handlePopupInteraction(BarryPopUpMessagAction.HIDE)
          }}
        >
          <Svg
            aria-label="close barry chat popup"
            descriptiveText="close barry chat popup"
            svg={CloseButtonPopUp}
            fill="aliceBlue"
          />
        </Button>
        <Flex
          data-testid="popup-message"
          onClick={() => {
            handlePopupInteraction(BarryPopUpMessagAction.OPEN)
          }}
        >
          {barryMessage}
        </Flex>
      </Flex>
      <Box
        sx={{
          position: 'absolute',
          bottom: '8.18rem',
          right: ['4.0rem', '4.8rem'],
          zIndex: 'zIndex625',
          width: 0,
          height: 0,
          borderTop: '0px solid transparent',
          borderBottom: '12px solid transparent',
          borderRight: ({ colors }) =>
            isLightMode
              ? `12px solid ${colors?.commonAliceBlue}`
              : `12px solid ${colors?.spaceCadet}`,
          filter: 'drop-shadow(0px 3px 3.5px rgba(0, 0, 0, 0.1))',
        }}
      />
    </>
  )
}
